import React, { useContext, useState } from "react";
import { Table, TableRow, TableBody, TableHead } from "@material-ui/core";

import StyledTableCell, {
  HeadRow,
} from "../../common/styled-table-cell.component";
import { createTableData } from "../../../utils/create-table-data";
import { MatchContext } from "../../../context";
import {
  APP_INSIGHTS_EVENTS,
  STOCKPILES_TABLE_FEATURES,
} from "../../../constants";
import { SET_HIGHLIGHTED_ROWS } from "../../../reduce/actionTypes";
import TableCellErrorMessage from "../../common/table-cell-error-message.component";
import StubCell from "../../common/stub-cell.component";
import Input from "./input.component";
import useStyles from "../../tables-container/styles";
import useHighlightTableItem from "../../../utils/hooks/use-higlight-table-item";
import prepareRowStyles from "../../../utils/prepare-row-styles";

const EmptyTable = ({
  columnsNumber,
  handleChangeTableWeights,
  handleChangeTableInputs,
  stockpilesTableFeatures,
}): JSX.Element => {
  const classes = useStyles();
  const [hoveredFeature, setHoveredFeature] = useState("");
  const { state } = useContext(MatchContext);
  const higlightItem = useHighlightTableItem();

  // fill table rows with data
  const rows = (() => {
    const data: any = [];

    for (let i = 0; i < Object.keys(stockpilesTableFeatures).length; i++) {
      data.push(
        createTableData(Object.values(stockpilesTableFeatures)[i] as string)
      );
    }

    return data;
  })();

  return (
    <Table aria-label="customized table">
      <TableHead className={classes.headFont}>
        <HeadRow>
          <StyledTableCell className={classes.weightCell} align="center">
            Weight
          </StyledTableCell>
          <StyledTableCell className={classes.featureCell} align="center">
            Feature
          </StyledTableCell>
          <StyledTableCell className={classes.headInputCell} align="center">
            Input
          </StyledTableCell>
          <StubCell columnsNumber={columnsNumber} />
        </HeadRow>
      </TableHead>
      <TableBody className={state.hideMatchingTable && "hidden"}>
        {rows.map((row) => {
          const feature: string = row.feature.toUpperCase();
          return (
            <TableRow
              key={feature}
              className={prepareRowStyles(row, state, hoveredFeature, true)}
            >
              <StyledTableCell align="center">
                <Input
                  type="number"
                  min="0"
                  max="100"
                  value={state.tableWeights[feature]}
                  id={feature}
                  onChange={handleChangeTableWeights}
                  datatype="weight"
                />
                <TableCellErrorMessage
                  feature={feature}
                  type="weight"
                  errors={state.inputErrors}
                />
              </StyledTableCell>
              <StyledTableCell
                align="center"
                onClick={() =>
                  higlightItem(
                    feature,
                    SET_HIGHLIGHTED_ROWS,
                    "highlightedRows",
                    APP_INSIGHTS_EVENTS.CHANGE_ROW_HIGHLIGHT
                  )
                }
                className={classes.dataCell}
                onMouseEnter={() => setHoveredFeature(feature)}
                onMouseLeave={() => setHoveredFeature("")}
              >
                {row.feature === STOCKPILES_TABLE_FEATURES.GRAIN_SIZE_T1
                  ? "% Type 1"
                  : row.feature === STOCKPILES_TABLE_FEATURES.GRAIN_SIZE_T2
                  ? "% Type 2"
                  : row.feature === STOCKPILES_TABLE_FEATURES.GRAIN_SIZE_T6
                  ? "% Type 6"
                  : row.feature ===
                    STOCKPILES_TABLE_FEATURES.GRAIN_SIZE_T1_GRAIN_SIZE_T6
                  ? "% Type 1 + % Type 6"
                  : row.feature.replace(/_/g, " ")}
              </StyledTableCell>
              <StyledTableCell className={classes.inputCell} align="center">
                <Input
                  type="number"
                  placeholder="-"
                  min="0"
                  max="100"
                  value={state.tableInputs[feature]}
                  id={feature}
                  onChange={handleChangeTableInputs}
                  datatype="input"
                  disabled={
                    row.feature === STOCKPILES_TABLE_FEATURES.ZNFE_RATIO ||
                    row.feature === STOCKPILES_TABLE_FEATURES.ZNPB_RATIO ||
                    row.feature === STOCKPILES_TABLE_FEATURES.PBFE_RATIO ||
                    row.feature === STOCKPILES_TABLE_FEATURES.RPB_RATIO
                  }
                />
                <TableCellErrorMessage
                  feature={feature}
                  type="input"
                  errors={state.inputErrors}
                />
              </StyledTableCell>
              <StubCell columnsNumber={columnsNumber} />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default EmptyTable;
